import _defineProperty from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import * as dayjs from 'dayjs';
import { toExpiration, getNextLegId, isString } from '..';
import { getDefaultOrderQuantity } from '../utilities/OrderUtilities';
export var LegBuilder =
/*#__PURE__*/
function () {
  function LegBuilder(rootSymbol, id) {
    var _this = this;

    _classCallCheck(this, LegBuilder);

    this.expiration = function (val, optionExpirationType) {
      var expVal = dayjs.isDayjs(val) ? val.toDate() : new Date(val);
      return _this.set('Expiration', toExpiration(expVal, _this.rootSymbol, optionExpirationType));
    };

    this.legState = {};
    this.rootSymbol = rootSymbol;
    this.id = id;
  }

  _createClass(LegBuilder, [{
    key: "set",
    value: function set(k, value) {
      this.legState = Object.assign({}, this.legState, _defineProperty({}, k, value));
      return this;
    }
  }, {
    key: "get",
    value: function get(k) {
      return this.legState[k];
    }
  }, {
    key: "optionType",
    value: function optionType(val) {
      return this.set('OptionType', val);
    }
  }, {
    key: "positionEffect",
    value: function positionEffect(val) {
      return this.set('PositionEffect', val);
    }
  }, {
    key: "assetType",
    value: function assetType(val) {
      return this.set('AssetType', val);
    }
  }, {
    key: "action",
    value: function action(act) {
      return this.set('Action', act);
    }
  }, {
    key: "quantity",
    value: function quantity(val) {
      return this.set('SpreadRatio', val || 1);
    }
  }, {
    key: "strike",
    value: function strike(val) {
      return this.set('Strike', val);
    }
  }, {
    key: "subaccountId",
    value: function subaccountId(val) {
      return this.set('SubaccountId', val);
    }
  }, {
    key: "leg",
    value: function leg() {
      var _this$legState = this.legState,
          Strike = _this$legState.Strike,
          Expiration = _this$legState.Expiration,
          SpreadRatio = _this$legState.SpreadRatio,
          Action = _this$legState.Action,
          PositionEffect = _this$legState.PositionEffect,
          AssetType = _this$legState.AssetType,
          OptionType = _this$legState.OptionType,
          SubaccountId = _this$legState.SubaccountId;
      return {
        Id: this.id,
        UnderlyingSymbol: this.rootSymbol,
        Expiration: Expiration,
        Strike: Strike,
        SpreadRatio: SpreadRatio,
        OptionType: OptionType,
        Action: Action,
        AssetType: AssetType,
        PositionEffect: PositionEffect,
        SubaccountId: SubaccountId
      };
    }
  }]);

  return LegBuilder;
}();
var OrderBuilderNoSymbolError = {
  error: 'you must set order symbol before creating legs'
};
export var OrderBuilder =
/*#__PURE__*/
function () {
  function OrderBuilder(ordDefaults) {
    _classCallCheck(this, OrderBuilder);

    this.orderState = {};
    this.dirty = {};
    this.order_defaults = ordDefaults;
  }

  _createClass(OrderBuilder, [{
    key: "set",
    value: function set(k, value) {
      this.dirty[k] = true;
      this.orderState = Object.assign({}, this.orderState, _defineProperty({}, k, value));
      return this;
    }
  }, {
    key: "leg",
    value: function leg(legBuilder) {
      var _this$orderState = this.orderState,
          symbol = _this$orderState.symbol,
          legs = _this$orderState.legs;

      if (this.orderState.symbol === undefined) {
        throw OrderBuilderNoSymbolError;
      }

      var existingLegs = legs || {};
      var legId = getNextLegId(existingLegs);
      this.orderState = Object.assign({}, this.orderState, {
        legs: Object.assign({}, existingLegs, _defineProperty({}, legId, legBuilder(new LegBuilder(symbol.rootSymbol, legId)).leg()))
      });
      return this;
    }
  }, {
    key: "duration",
    value: function duration(val) {
      return this.set('duration', val);
    }
  }, {
    key: "strategy",
    value: function strategy(_strategy) {
      var strategyName = isString(_strategy) ? _strategy : _strategy.info.Name;
      var updated = this.set('strategy', strategyName);
      var orderDefs = this.order_defaults;

      if (orderDefs && !this.dirty['quantity']) {
        return updated.set('quantity', getDefaultOrderQuantity(strategyName, orderDefs));
      }

      return updated;
    }
  }, {
    key: "symbol",
    value: function symbol(_symbol) {
      return this.set('symbol', _symbol);
    }
  }, {
    key: "quantity",
    value: function quantity(val) {
      return this.set('quantity', val);
    }
  }, {
    key: "orderType",
    value: function orderType(val) {
      return this.set('orderType', val);
    }
  }, {
    key: "creditOrDebit",
    value: function creditOrDebit(val) {
      return this.set('debitCredit', val);
    }
  }, {
    key: "action",
    value: function action(val) {
      return this.set('action', val);
    }
  }, {
    key: "orderDefaults",
    value: function orderDefaults(defaultValues) {
      this.order_defaults = defaultValues;
      return this;
    }
  }, {
    key: "order",
    value: function order() {
      return this.orderState;
    }
  }, {
    key: "subaccountId",
    value: function subaccountId(val) {
      return this.set('subaccountId', val);
    }
  }]);

  return OrderBuilder;
}();